{
  "v8e.code.CONFLIT_DE_VERSION": "Quelqu’un a modifié cet élément entre-temps : relisez-le puis recommencez.",
  "v8e.code.CONTEXTE_INCOMPLET": "Le contexte de l’organisation est incomplet : rouvrez l’écran depuis votre organisation.",
  "v8e.code.DELEGATION_ALREADY_REVOKED": "Cette délégation est déjà révoquée.",
  "v8e.code.DELEGATION_DELEGATE_NOT_IN_ORGANISATION": "Le délégué n’est pas une personne active de l’organisation.",
  "v8e.code.DELEGATION_DELEGATOR_ROLE_MISSING": "Le délégant ne tient pas ce profil sur l’objet choisi.",
  "v8e.code.DELEGATION_DROIT_RESERVE": "La propriété et les droits réservés au propriétaire ne se délèguent jamais.",
  "v8e.code.DELEGATION_IMMUTABLE": "Une délégation ne se modifie pas : révoquez-la et déclarez-en une autre.",
  "v8e.code.DELEGATION_SELF_REFUSED": "On ne se délègue pas un profil à soi-même : choisissez un autre délégué.",
  "v8e.code.DELEGATION_WINDOW_INVALID": "La fin doit être future, après le début, et la délégation durer {{jours}} jours au plus.",
  "v8e.code.DROIT_NON_TENU": "Vous n’avez pas le droit requis pour ce geste.",
  "v8e.code.GARDE_DROIT_ABSENTE": "Ce geste n’est pas encore ouvert : aucune garde de droit ne le protège.",
  "v8e.code.NOM_DEJA_PRIS": "Ce nom est déjà porté dans l’organisation.",
  "v8e.code.ORG_ADMIN_REQUIRED": "Ce geste est réservé à l’administration de l’organisation.",
  "v8e.code.RESOURCE_UNAVAILABLE": "Cet élément est introuvable dans votre organisation.",
  "v8e.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v8e.code.V8E_MODELE_NON_PROPOSE": "Ce modèle n’est pas proposé par l’organisation : choisissez-en un autre.",
  "v8e.code.VALIDATION_ERROR": "Une valeur saisie est refusée : vérifiez les champs signalés.",
  "v8e.commun.etat.chargement": "Chargement : {{quoi}}…",
  "v8e.commun.etat.en_cours": "Enregistrement en cours…",
  "v8e.commun.etat.erreur": "{{quoi}} n’a pas pu être lu.",
  "v8e.commun.etat.introuvable": "{{quoi}} est introuvable.",
  "v8e.commun.etat.reessayer": "Réessayer",
  "v8e.commun.etat.refus": "Vous n’avez pas le droit de voir {{quoi}}.",
  "v8e.commun.etat.vide": "Rien à afficher.",
  "v8e.commun.geste.annuler": "Annuler",
  "v8e.commun.geste.erreur": "Le geste n’a pas abouti.",
  "v8e.commun.geste.fermer": "Fermer",
  "v8e.delegations.adresse_invalide": "Cette adresse ne désigne aucune délégation.",
  "v8e.delegations.aucun_objet.programme": "Aucun programme dans l’organisation.",
  "v8e.delegations.aucun_objet.projet": "Aucun projet dans l’organisation.",
  "v8e.delegations.aucun_profil": "Aucun profil délégable",
  "v8e.delegations.aucun_profil_delegable": "Ce délégant ne tient ici que la propriété, qui ne se délègue jamais.",
  "v8e.delegations.champ.date_fin": "Date de fin",
  "v8e.delegations.champ.debut": "À partir du",
  "v8e.delegations.champ.declaree_par": "Déclarée par",
  "v8e.delegations.champ.delegant": "Délégant",
  "v8e.delegations.champ.delegue": "Délégué",
  "v8e.delegations.champ.fin": "Jusqu’au",
  "v8e.delegations.champ.motif": "Motif",
  "v8e.delegations.champ.objet.programme": "Programme",
  "v8e.delegations.champ.objet.projet": "Projet",
  "v8e.delegations.champ.portee": "Porte sur",
  "v8e.delegations.champ.revoquee_par": "Révoquée par",
  "v8e.delegations.champ.role": "Profil délégué",
  "v8e.delegations.champ.type_objet": "Objet de la délégation",
  "v8e.delegations.choisir": "Choisir une personne",
  "v8e.delegations.debut_aide": "Vide : maintenant.",
  "v8e.delegations.declaree": "Délégation déclarée.",
  "v8e.delegations.declarer": "Déclarer une délégation",
  "v8e.delegations.delegant_requis": "Choisissez le délégant.",
  "v8e.delegations.delegue_requis": "Choisissez le délégué.",
  "v8e.delegations.echeance.date_choisie": "Date choisie",
  "v8e.delegations.echeance.deux_semaines": "Deux semaines",
  "v8e.delegations.echeance.une_semaine": "Une semaine",
  "v8e.delegations.etat.active": "Active",
  "v8e.delegations.etat.expired": "Expirée",
  "v8e.delegations.etat.revoked": "Révoquée",
  "v8e.delegations.etat.scheduled": "Programmée",
  "v8e.delegations.filtre": "État de la délégation",
  "v8e.delegations.filtre.active": "Actives",
  "v8e.delegations.filtre.expiree": "Expirées",
  "v8e.delegations.filtre.programmee": "Programmées",
  "v8e.delegations.filtre.revoquee": "Révoquées",
  "v8e.delegations.filtre.toutes": "Toutes",
  "v8e.delegations.jamais.propriete": "Jamais délégués : la propriété et les droits réservés au propriétaire.",
  "v8e.delegations.jamais.separation": "La séparation des tâches reste entière : le délégué n’approuve jamais ce qu’il a lui-même créé.",
  "v8e.delegations.ligne": "{{role}} de {{delegant}} vers {{delegue}} sur {{objet}}, jusqu’au {{fin}}",
  "v8e.delegations.motif_aide": "5 caractères au moins ; tracé au journal.",
  "v8e.delegations.motif_requis": "Le motif compte 5 caractères au moins.",
  "v8e.delegations.onglet.delegations": "Délégations",
  "v8e.delegations.onglet.reglages": "Réglages et arrêt d’urgence",
  "v8e.delegations.onglets": "Gouvernance de l’organisation",
  "v8e.delegations.portee.programme": "le programme",
  "v8e.delegations.portee.projet": "le projet",
  "v8e.delegations.recap.maintenant": "Active dès maintenant, jusqu’au {{fin}}.",
  "v8e.delegations.recap.programmee": "Programmée du {{debut}} au {{fin}}.",
  "v8e.delegations.recap.verification": "Les droits du délégant sont revérifiés à chaque décision : s’il perd le profil, la délégation cesse d’agir.",
  "v8e.delegations.revoquer": "Révoquer la délégation",
  "v8e.delegations.revoquer.confirmation": "Après la révocation, le délégué ne peut plus agir à la place du délégant.",
  "v8e.delegations.revoquer.confirmer": "Confirmer la révocation",
  "v8e.delegations.revoquer.reussie": "Délégation révoquée.",
  "v8e.delegations.role.contributor": "Contributeur",
  "v8e.delegations.role.owner": "Propriétaire",
  "v8e.delegations.role.viewer": "Lecteur",
  "v8e.delegations.toutes": "Toutes les délégations",
  "v8e.delegations.vide": "Aucune délégation dans cet état.",
  "v8e.delegations.voir": "Voir la délégation",
  "v8e.delegations.vous": "Vous ({{nom}})",
  "v8e.ecran.dialogue-ajouter-attribution-invitation.titre": "Ajouter une attribution à une invitation en attente",
  "v8e.ecran.dialogue-annuler-suppression-projet.titre": "Annuler la suppression programmée d’un projet",
  "v8e.ecran.dialogue-archiver-projet.titre": "Archiver un projet — confirmation",
  "v8e.ecran.dialogue-creer-programme.titre": "Créer un programme dans l’organisation",
  "v8e.ecran.dialogue-creer-projet.titre": "Créer un projet dans l’organisation",
  "v8e.ecran.dialogue-declarer-delegation.titre": "Déclarer une délégation pendant une absence",
  "v8e.ecran.dialogue-rattacher-projet-programme.titre": "Rattacher un projet à un programme, ou l’en détacher",
  "v8e.ecran.dialogue-renommer-projet.titre": "Renommer un projet",
  "v8e.ecran.dialogue-retirer-appartenance.titre": "Retirer une personne d’un projet ou d’un programme — confirmation",
  "v8e.ecran.dialogue-retirer-attribution-invitation.titre": "Retirer une attribution d’une invitation en attente — confirmation",
  "v8e.ecran.dialogue-supprimer-categorie.titre": "Supprimer une catégorie — confirmation",
  "v8e.ecran.dialogue-supprimer-projet.titre": "Programmer la suppression d’un projet (différée, annulable)",
  "v8e.ecran.organisation-accueil-administration.titre": "Accueil de l’administration de l’organisation",
  "v8e.ecran.organisation-delegation-fiche.titre": "Délégation — fiche",
  "v8e.ecran.organisation-delegations.titre": "Délégations de l’organisation",
  "v8e.ecran.organisation-fiche.titre": "Mon organisation",
  "v8e.ecran.organisation-invitation-fiche.titre": "Invitation — fiche",
  "v8e.ecran.organisation-journal.titre": "Journal de l’organisation",
  "v8e.ecran.organisation-lancement-projet.titre": "Lancement d’un projet — composition et technologies",
  "v8e.ecran.organisation-lancements.titre": "Lancements de projet à terminer",
  "v8e.ecran.organisation-premiers-pas.titre": "Premiers pas de mon organisation",
  "v8e.ecran.organisation-programmes.titre": "Programmes de l’organisation",
  "v8e.ecran.organisation-projet-suppression-fiche.titre": "Demande de suppression d’un projet",
  "v8e.ecran.organisation-projets.titre": "Projets de l’organisation",
  "v8e.ecran.organisation-vue-d-ensemble.titre": "Vue d’ensemble de l’organisation"
}
